export const data = [
    {
      name: 'Jan',
      female: 30,
      male: 20,
     
     
    },
    {
      name: 'Feb',
     
      male: 710,
      female: 98,
    },
    {
      name: 'Mar',
      female: 98,
      male: 10,
     
    },
    {
      name: 'Apr',
      female: 698,
      male: 410,
     
    },
    {
      name: 'May',
      female: 58,
      male: 20,
     
    },
    {
      name: 'Jun',
      female: 798,
      male: 510,
     
    },
   
    {
      name: 'Jul',
      female: 58,
      male: 40,
     
    },
    {
      name: 'Agu',
      female: 53,
      male: 64,
     
    },
    {
      name: 'Sep',
      female: 345,
      male: 454,
     
    },
    {
      name: 'Oct',
      female: 76,
      male: 56,
     
    },
    {
      name: 'Nov',
      female: 98,
      male: 32,
     
    },
    {
        name: 'Dec',
        female: 345,
      male: 345,
       
      }
  ];
  
 